import { useFormikContext } from "formik";
import React, { useState } from "react";
import EN from "../../locales/en";
import interpolate from "../../utils/interpolate";
import Button from "../Button";
import AdditionalSupportModal from "./AdditionalSupportModal";
import DisclosureSection from "./partials/DisclosureSection";
import RadioField from "./partials/RadioField";

const AdditionalSupport = ({
  supplierName,
  supplierTermsInfo,
  values,
  isSubmitting,
}) => {
  const { setFieldValue } = useFormikContext();
  const [showAdditionalSupportModal, setShowAdditionalSupportModal] =
    useState(false);
  const [hasAdditionalSupport, setHasAdditionalSupport] = useState(false);

  const selectedPsrOptions = values?.psr?.options
    ? values?.psr?.options?.filter((option) => option?.selected === true)
    : [];

  const selectedPsrOptionsText = selectedPsrOptions
    ?.map((option) => option?.displayName)
    .join(", ");

  const clearPsrOptions = () => {
    setFieldValue(
      "psr.options",
      values?.psr?.options?.map((option) => {
        const { selected, ...rest } = option;
        return rest;
      })
    );
  };

  const handleRemove = () => {
    clearPsrOptions();
  };

  const handleAdd = () => {
    setShowAdditionalSupportModal(true);
  };

  const handleYes = () => {
    setHasAdditionalSupport(true);
    setShowAdditionalSupportModal(true);
  };

  const handleNo = () => {
    setHasAdditionalSupport(false);
    setShowAdditionalSupportModal(false);
    handleRemove();
  };

  return (
    <>
      <div className="mt-8 border-t border-[#afb6b9]">
        <h2 className="text-[30px] font-bold text-primary mt-6">
          {EN.switch.additional_support.title}
        </h2>
        <p className="text-md leading-[1.5] mt-2">
          {EN.switch.additional_support.description}
        </p>
        <DisclosureSection
          title={EN.switch.additional_support.priority_services_register.title}
          content={
            <p>
              {EN.switch.additional_support.priority_services_register.content}
            </p>
          }
        />
        <h3 className="text-[22px] font-bold mt-6">
          {interpolate(EN.switch.additional_support.require_support, {
            supplierName,
          })}
        </h3>
        <RadioField
          name="psr.hasVulnerabilities"
          label={EN.switch.additional_support.yes_label}
          value="true"
          onClick={handleYes}
          hideErrorMessage={true}
          disabled={isSubmitting}
        />
        <RadioField
          name="psr.hasVulnerabilities"
          label={EN.switch.additional_support.no_label}
          value="false"
          onClick={handleNo}
          disabled={isSubmitting}
        />
        {hasAdditionalSupport && (
          <div>
            <h3 className="text-[22px] font-bold mt-6">
              {EN.switch.additional_support.conditions_title}
            </h3>
            {selectedPsrOptions.length > 0 ? (
              <>
                <p className="mt-4">{selectedPsrOptionsText}</p>
                <div className="flex justify-between gap-6 mt-6">
                  <Button
                    type="button"
                    variant="secondary"
                    fullWidth
                    onClick={handleRemove}
                    disabled={isSubmitting}
                  >
                    {EN.switch.additional_support.remove_conditions}
                  </Button>
                  <Button
                    type="button"
                    fullWidth
                    onClick={handleAdd}
                    disabled={isSubmitting}
                  >
                    {EN.switch.additional_support.edit_conditions}
                  </Button>
                </div>
              </>
            ) : (
              <Button
                className="mt-2"
                type="button"
                variant="secondary"
                fullWidth
                onClick={handleAdd}
                disabled={isSubmitting}
              >
                {EN.switch.additional_support.add_conditions}
              </Button>
            )}
          </div>
        )}
      </div>
      <AdditionalSupportModal
        open={showAdditionalSupportModal}
        setOpen={setShowAdditionalSupportModal}
        supplierTermsInfo={supplierTermsInfo}
        clearPsrOptions={clearPsrOptions}
        values={values}
      />
    </>
  );
};

export default AdditionalSupport;
